

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import { ISaveResponse } from "@/model/ISaveResponse";
    import { IBriefing, Briefing } from "@/model/Briefing";
    import { ILookupItem } from "@/model/LookupItem";
    import { ISiteLookup } from "@/model/Site";
import { IClientLookup } from "@/model/Client";

    @Component({ components: { ApiButton } })
    export default class BriefingCloneDialogue extends Vue {

        //
        // -- properties
        //

        @Ref("briefingForm") readonly briefingForm!: VForm;
        showDialogue: boolean = false;

        @Prop({ required: true })
        clientList!: Array<IClientLookup>;
        get clientOptions(): Array<IClientLookup> { return Utils.clientOptionsFilter(this.clientList); }

        @Prop({ required: true })
        siteList!: Array<ISiteLookup>;
        get siteOptions(): Array<ISiteLookup> { return Utils.siteOptionsFilter(this.siteList, this.targetClientID); }

        sourceBriefingID: string = "";
        sourceBriefingName: string = "";
        targetBriefingName: string = "";
        targetClientID: string = "";
        targetSiteID: string = "";

        //
        // -- methods
        //

        async show(source: IBriefing): Promise<void> {
            this.sourceBriefingID = source.id;
            this.sourceBriefingName = source.name;
            this.targetBriefingName = "Copy of: " + source.name;
            this.targetClientID = source.clientID;
            this.targetSiteID = source.siteID;
            this.showDialogue = true;
        }

        async clone(): Promise<void> {
            if (!this.briefingForm.validate()) {
                toastr.warning("Please fix highlighted issues to continue.");
                return;
            }
            const request = {
                sourceID: this.sourceBriefingID,
                targetName: this.targetBriefingName,
                targetSiteID: this.targetSiteID
            };
            const response: ISaveResponse = await ApiClient.post("/api/briefing/clone", request, "briefing-clone");
            toastr.success("Cloned");
            this.$emit("cloned", response.newID);
            this.showDialogue = false;
        }

    }
